export enum LogInErrors {
  InternalServerError = 'Internal server error',
  UnconfirmedUser = 'User is not confirmed.',
}
